export const AI_ASSISTANT_CHAT_HISTORY_LOCAL_STORAGE_KEY = "ai_assistant_chat_history";
export const AI_ASSISTANT_CHAT_ID_LOCAL_STORAGE_KEY = "ai_assistant_chat_id";
